/* eslint-disable max-len */
/* eslint-disable eqeqeq */
import { Card } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { Field, FieldArray, Form, Formik } from 'formik';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import Header from '../common/Header';
import closeIcon from '../../images/icons/cross.svg';
import Footer from '../common/Footer';
import DropdownFieldComponent from '../common/FormComponents/DropdownFieldComponent';
import InputFieldComponent from '../common/FormComponents/InputFieldComponent';
import MultiSelectFieldComponent from '../common/FormComponents/MultiSelectFieldComponent';
import fetchExpenseItems from '../expenseItem/queries/fetchExpenseItems';
import formatDropdownOptions from '../../utils/formatDropdownOptions';
import getVendorList from './queries/getVendorList';
import editVendor from './queries/editVendor';
import showAlert from '../../utils/alert';
import deleteEachVendorExpense from './queries/deleteEachVendorExpense';
import getFilteredExpenseItemList from '../../utils/getFilteredExpenseItemList';
import getExpenseCategoryJSONlist from '../po/queries/getExpenseCategoryJsonList';
import { returnPolicies } from '../../PermissionUtility/ProfilePolicies';
import { fetchVesselRoles } from '../expenseItem/queries/fetchVesselRoles';
import { validationSchema, validateEmailField, shortCloseApprovalOptions, numberOfLevelsOptions } from './VendorHelper';

const checkExpenseError = ({ touched, errors, fieldName, index }) => {
  if (touched.expense?.[index]?.[fieldName] && errors.expense?.[index]?.[fieldName]) {
    return errors.expense?.[index]?.[fieldName];
  }
  return '';
};

const emptyExpenseObj = {
  expenseCategoryID: '',
  expenseLineItemID: '',
  accountCode: ''
};

const AddEditVendor = () => {
  const params = useHistory();
  const history = useHistory();
  const policies = returnPolicies();
  const [vesselRoles, setVesselRoles] = useState([]);
  const [emailErrors, setEmailErrors] = useState({
    level1ApproverEmail: '',
    level2ApproverEmail: ''
  });

  const {
    id: vendorName,
    address,
    company,
    email,
    vendorExpense,
    numberOfLevels,
    shortCloseApprovalRequired,
    vendorDashboardAccessRequired,
    approvers
  } = params?.location?.state || {};

  const level1ApproverData = approvers?.find((approver) => approver.level === 1);
  const level2ApproverData = approvers?.find((approver) => approver.level === 2);

  const { data: ExpenseItemsFirstLoad } = fetchExpenseItems({ pageNumber: 1, rowsCount: 10 });
  const { data: ExpenseItems } = fetchExpenseItems({
    pageNumber: 1,
    rowsCount: ExpenseItemsFirstLoad?.data?.totalRowsCount
  });

  useEffect(() => {
    const loadVesselRoles = async () => {
      try {
        const roles = await fetchVesselRoles();
        setVesselRoles(roles);
      } catch (error) {
        toast.error('Failed to fetch vessel roles:');
      }
    };
    loadVesselRoles();
  }, []);

  const expenseItemList = formatDropdownOptions(ExpenseItems?.data?.expenseItemModels, 'expenseLineItem', 'expenseLineItemID');
  const {
    data: expenseCategory
  } = getExpenseCategoryJSONlist();
  const categoryList = formatDropdownOptions(expenseCategory?.data, 'categoryName', 'expenseCategoryID');
  const { data: vendors } = getVendorList();
  const vendorList = formatDropdownOptions(vendors?.data, 'vendorName', 'id');

  const { mutate: handleEditVendor, isSuccess, isError, isLoading: isEditLoading } = editVendor();

  const { mutate: deleteVendorExpense } = deleteEachVendorExpense();
  if (isSuccess) {
    showAlert('Vendor Updated Successfully', 'success');
    history.push('/vendors');
  }

  if (isError) {
    showAlert('Expense mapping already exists', 'error');
  }

  const checkDisable = (dataObj) => {
    if (dataObj) {
      const { expenseCategoryID, expenseLineItemID } = dataObj;
      const parsedObj = {
        expenseCategoryID,
        expenseLineItemID
      };
      const check = Object.values(parsedObj).some((i) => i === '');
      return check;
    }
    return false;
  };

  const handleCancel = () => {
    history.push('/vendors');
  };
  const array = [];
  const handleDelete = (arrayHelpers, index, vendorExpenseitemID) => {
    if (vendorExpenseitemID) {
      array.push(vendorExpenseitemID);
    }
    arrayHelpers.remove(index);
  };
  const deleteSavedVendorExpense = (values) => {
    if (array.length > 0) {
      array.forEach((item) => {
        deleteVendorExpense(item);
      });
    }
    handleEditVendor(values);
  };

  useEffect(() => {
    if (policies?.vendorPolicies?.canAccess === false) {
      history.push('/');
    }
  }, [policies]);

  function transformRoles(rolesArray) {
    return rolesArray.map((role) => ({
      label: role.roleName,
      value: role.roleIdentifier
    }));
  }

  const handleEmailChange = (fieldName, value, values, setFieldValue) => {
    setFieldValue(fieldName, value);

    const error = validateEmailField(
      value,
      values.level1Approver,
      values.level2Approver,
      values.shortCloseApprovalRequired,
      values.numberOfLevels,
      fieldName === 'level1ApproverEmail' ? 'level1' : 'level2'
    );

    setEmailErrors((prev) => ({
      ...prev,
      [fieldName]: error
    }));
  };

  const ApproverOptions = transformRoles(vesselRoles);

  return (
    <>
      <div className="flex flex-col grow">
        <Header parentPageLink="/vendors" currentPage="Edit Vendor" parentPage="Vendor List" headerName="Vendor to Expense Mapping" />
        <Formik
          initialValues={{
            vendorName,
            company: formatDropdownOptions(company, 'name', 'id'),
            address,
            email,
            expense: vendorExpense?.length > 0 ? vendorExpense : [emptyExpenseObj],
            shortCloseApprovalRequired: shortCloseApprovalRequired === true ? 'yes' : 'no',
            numberOfLevels: numberOfLevels || '',
            level1Approver: level1ApproverData?.roleIdentifier || '',
            level1ApproverEmail: level1ApproverData?.emailOfVendor || email,
            level2Approver: level2ApproverData?.roleIdentifier || '',
            level2ApproverEmail: level2ApproverData?.emailOfVendor || email,
            vendorDashboardAccessRequired: vendorDashboardAccessRequired || false
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            deleteSavedVendorExpense(values);
          }}
        >
          {({ values, errors, touched, setFieldValue }) => {
            const prevNumberOfLevels = useRef(values.numberOfLevels);
            useEffect(() => {
              if (values.level1Approver === 'vendor') {
                setFieldValue('level1ApproverEmail', level1ApproverData?.emailOfVendor || email);
              }
              if (values.level2Approver === 'vendor') {
                setFieldValue('level2ApproverEmail', level2ApproverData?.emailOfVendor || email);
              }
            }, [values.level1Approver, values.level2Approver, values.email, setFieldValue]);
            useEffect(() => {
                if (values.numberOfLevels !== prevNumberOfLevels.current) {
                if (values.numberOfLevels < 1) {
                  setFieldValue('level1Approver', '');
                  setFieldValue('level1ApproverEmail', '');
                if (level1ApproverData) {
                  level1ApproverData.emailOfVendor = null;
                }
                }
                if (values.numberOfLevels !== 2) {
                  setFieldValue('level2Approver', '');
                  setFieldValue('level2ApproverEmail', '');
                if (level2ApproverData) {
                  level2ApproverData.emailOfVendor = null;
                }
                }
                prevNumberOfLevels.current = values.numberOfLevels;
              }
            }, [values.numberOfLevels, setFieldValue]);
            useEffect(() => {
              if (values.shortCloseApprovalRequired === 'no') {
                setFieldValue('numberOfLevels', '');
                setFieldValue('level1Approver', '');
                setFieldValue('level1ApproverEmail', '');
                setFieldValue('level2Approver', '');
                setFieldValue('level2ApproverEmail', '');
                if (level1ApproverData) {
                  level1ApproverData.emailOfVendor = null;
                }
                if (level2ApproverData) {
                  level2ApproverData.emailOfVendor = null;
                }
                setEmailErrors({
                  level1ApproverEmail: '',
                  level2ApproverEmail: ''
                });
              }
            }, [values.shortCloseApprovalRequired, setFieldValue]);
            return (
              <Form className="grow" id="my-form" style={{ height: '100vh' }}>
                <div className="mx-22 pb-4 ">
                  <Card className="h-full overflow-visible-custom " variant="Header">
                    <div className="mx-10 my-4">
                      <div className="uppercase text-lg font- font-bold">Edit vendor</div>
                      <div className="grid grid-cols-3 gap-6 my-4 ">
                        <Field
                          name="vendorName"
                          component={DropdownFieldComponent}
                          className="w-full"
                          options={vendorList}
                          rounded
                          id="select1"
                          type="text"
                          placeholder=""
                          label="Vendor"
                          isDisabled
                        />

                        <Field
                          name="address"
                          component={InputFieldComponent}
                          id="number"
                          variant="text"
                          rounded
                          autoComplete="off"
                          placeholder=""
                          label="Address"
                          disabled
                        />
                        <Field
                          name="email"
                          component={InputFieldComponent}
                          id="number"
                          variant="text"
                          rounded
                          autoComplete="off"
                          placeholder=""
                          label="Vendor Email"
                          disabled
                        />

                        <div className="col-span-full">
                          <Field
                            name="company"
                            component={MultiSelectFieldComponent}
                            className="w-full"
                            rounded
                            id="select1"
                            type="text"
                            placeholder=""
                            label="Company"
                            isDisabled
                          />
                        </div>
                      </div>
                      <div className="uppercase text-lg font- font-bold">Short-Close Approval</div>
                      <div className="grid grid-cols-3 gap-6 my-4 ">
                        <Field
                          name="shortCloseApprovalRequired"
                          component={DropdownFieldComponent}
                          className="w-full"
                          options={shortCloseApprovalOptions}
                          rounded
                          id="select1"
                          type="text"
                          placeholder=""
                          label="Short Close Approval Required"
                        />
                        {values.shortCloseApprovalRequired === 'yes' && (
                          <div className="relative">
                            <Field
                              name="numberOfLevels"
                              component={DropdownFieldComponent}
                              className="w-full"
                              options={numberOfLevelsOptions}
                              rounded
                              id="select1"
                              type="text"
                              placeholder=""
                              label="Number of Levels"
                              requiredField
                            />
                          </div>
                        )}
                      </div>
                      {values.shortCloseApprovalRequired === 'yes' && values.numberOfLevels >= 1 && (
                        <div className="grid grid-cols-3 gap-6 my-6">
                          <Field
                            name="level1Approver"
                            component={DropdownFieldComponent}
                            className="w-full"
                            options={ApproverOptions}
                            rounded
                            id="select1"
                            type="text"
                            placeholder=""
                            label="Level 1 - Approver"
                            requiredField
                          />
                              {values.level1Approver === 'vendor' && (
                                <div className="relative level-one-vendor-email">
                                  <Field
                                    name="level1ApproverEmail"
                                    component={InputFieldComponent}
                                    id="level1Email"
                                    variant="text"
                                    rounded
                                    autoComplete="off"
                                    placeholder="Enter vendor email"
                                    label=""
                                    showError={false}
                                    onChange={(e) => handleEmailChange('level1ApproverEmail', e.target.value, values, setFieldValue)}
                                  />
                                      {(emailErrors.level1ApproverEmail || (touched.level1ApproverEmail && errors.level1ApproverEmail)) && (
                                        <div className="error text-xs absolute -bottom-5 left-0">
                                          {emailErrors.level1ApproverEmail || errors.level1ApproverEmail}
                                        </div>
                                      )}
                                </div>
                              )}
                        </div>
                      )}

                      {values.shortCloseApprovalRequired === 'yes' && values.numberOfLevels === 2 && (
                        <div className="grid grid-cols-3 gap-6 my-6 relative">
                          <Field
                            name="level2Approver"
                            component={DropdownFieldComponent}
                            className="w-full"
                            options={ApproverOptions}
                            rounded
                            id="select2"
                            type="text"
                            placeholder=""
                            label="Level 2 - Approver"
                            requiredField
                          />
                          {values.level2Approver === 'vendor' && (
                            <div className="relative level-two-vendor-email">
                              <Field
                                name="level2ApproverEmail"
                                component={InputFieldComponent}
                                id="level2Email"
                                variant="text"
                                rounded
                                autoComplete="off"
                                placeholder="Enter vendor email"
                                label=""
                                onChange={(e) => handleEmailChange('level2ApproverEmail', e.target.value, values, setFieldValue)}
                              />
                              {(emailErrors.level2ApproverEmail || (touched.level2ApproverEmail && errors.level2ApproverEmail)) && (
                                <div className="error text-xs absolute -bottom-5 left-0">
                                  {emailErrors.level2ApproverEmail || errors.level2ApproverEmail}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      )}

                      {((values.level1Approver === 'vendor' || values.level2Approver === 'vendor') && values.shortCloseApprovalRequired === 'yes') && (
                        <div className="flex items-center gap-2 mt-7">
                          <label>Dashboard Access Required </label>
                          <label className="toggle-switch">
                            <input
                              type="checkbox"
                              checked="true"
                            />
                            <span className="slider" />
                          </label>
                        </div>
                      )}
                      <div className="flex flex-col gap-5 pt-8 pb-12 ">
                        <FieldArray
                          name="expense"
                          render={(arrayHelpers) => (
                            <>
                              <div className="flex justify-between items-center">
                                <div className="uppercase text-lg font- font-bold">Expense item mapping</div>
                                {policies?.vendorPolicies?.canEdit && (
                                  <button
                                    type="button"
                                    className="custom-primary-btn"
                                    onClick={() => arrayHelpers.unshift(emptyExpenseObj)}
                                    disabled={checkDisable(values?.expense?.[0])}
                                  >
                                    <span className="text-2xl">+</span>
                                  </button>
                                )}
                              </div>
                              {values.expense && values.expense.length > 0 ? (
                                values.expense.map((exp, index) => (
                                  <div
                                    className="grid grid-col-3-min
                                  items-center gap-4 newDataError "
                                  >
                                    <div className="">
                                      <Field
                                        name={`expense[${index}].expenseCategoryID`}
                                        component={DropdownFieldComponent}
                                        className="w-full"
                                        options={categoryList}
                                        rounded
                                        isDisabled={policies?.vendorPolicies?.canEdit === false}
                                        id="select1"
                                        type="text"
                                        placeholder="Expense Category"
                                        setFieldsNull={[`expense[${index}].expenseLineItemID`, `expense[${index}].accountCode`]}
                                      />

                                      <div className="error text-xs">
                                        {checkExpenseError({
                                          touched,
                                          errors,
                                          index,
                                          fieldName: 'expenseCategoryID'
                                        })}
                                      </div>
                                    </div>
                                    <div>
                                      <Field
                                        name={`expense[${index}].expenseLineItemID`}
                                        component={DropdownFieldComponent}
                                        className="w-full"
                                        options={
                                          getFilteredExpenseItemList(
                                            values?.expense[index], expenseItemList
                                          )
                                        }
                                        rounded
                                        isDisabled={policies?.vendorPolicies?.canEdit === false}
                                        id="select1"
                                        type="text"
                                        placeholder="Expense Item"
                                        isDynamic
                                        dependentfieldName={`expense[${index}].accountCode`}
                                        dependentfieldValue={expenseItemList}
                                      />
                                      <div className="error text-xs">
                                        {checkExpenseError({
                                          touched,
                                          errors,
                                          index,
                                          fieldName: 'expenseLineItemID'
                                        })}
                                      </div>
                                    </div>

                                    <div>
                                      {' '}
                                      <Field
                                        name={`expense[${index}].accountCode`}
                                        component={InputFieldComponent}
                                        id="number"
                                        variant="text"
                                        rounded
                                        autoComplete="off"
                                        placeholder="Account Code"
                                        disabled
                                      />
                                      <div className="error text-xs">
                                        {checkExpenseError({
                                          touched,
                                          errors,
                                          index,
                                          fieldName: 'accountCode'
                                        })}
                                      </div>
                                    </div>
                                    {policies?.vendorPolicies?.canEdit && (
                                      <button
                                        type="button"
                                        className="custom-secondary-btn ml-auto"
                                        onClick={
                                          () => handleDelete(
                                            arrayHelpers, index, exp?.vendorExpenseMappingID
                                          )
                                        }
                                      >
                                        <img src={closeIcon} alt="plus_icon" />
                                      </button>
                                    )}
                                  </div>
                                ))
                              ) : (
                                <div className="font-muli text-sm">Please Click on Plus Icon to Add Expense Item Mapping </div>
                              )}
                            </>
                          )}
                        />
                      </div>
                    </div>
                  </Card>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
      <Footer isLoading={isEditLoading} handleCancel={handleCancel} setDraft={() => {}} page="vendorMapping" />
    </>
  );
};

export default AddEditVendor;
